import $ from "jquery"

const customInputContactFile = () => {
  $(document).on(
    "input",
    '.mi-ContactPageForm input[type="file"]',
    function (e) {
      $(this)
        .parent()
        .parent()
        .append(
          `<style>.mi-Form__FileInputField.mi-Form__FileInputField.mi-Form__FileInputField label::before{content: "${e.target.files[0].name}" !important}</style>`,
        )
    },
  )
}
const customInputFile = () => {
  $(document).on("input", '.mi-JobsFormInput input[type="file"]', function (e) {
    $(this)
      .parent()
      .parent()
      .append(
        `<style>.mi-Form__FileInputField.mi-Form__FileInputField.mi-Form__FileInputField label::before{content: "${e.target.files[0].name}" !important}</style>`,
      )
  })
}

const disableButton = () => {
  $(document).ready(function () {
    const forms = [
      {
        form: $("#gform_5"),
        button: $("#gform_submit_button_5"),
      },
      {
        form: $("#gform_12"),
        button: $("#gform_submit_button_10"),
      },
    ]

    // console.log("asdasdasd")

    forms.forEach(function (formData) {
      const { form, button } = formData
      button.prop("disabled", true)
      // button.disabled = true

      const validateForm = function () {
        let isValid = true
        form.find("[aria-required]").each(function () {
          if (!$(this).val() === true) {
            isValid = false
          }
        })

        // console.log($(this).val())
        button.prop("disabled", !isValid)
      }

      form.on("keyup change submit", validateForm)
    })
  })
}

customInputFile()
customInputContactFile()
disableButton()
